import { get } from "lodash";

const rootURL = process.env.REACT_APP_ROOT_URL;

export default function fetchHandler(
	{
		url,
		method = "GET",
		actionType,
		headers,
		body,
		secure = true,
		shouldDispatch = true,
		external = false,
		isFileUpload = false
	},
	successHandler = null,
	errorHandler = null
) {
	return async (dispatch, getState) => {
		const token = get(getState(), "Auth.userDetails.token", null);

		let headersData = isFileUpload
			? headers
			: {
					Accept: "*/*",
					"Content-Type": "application/json",
					...headers
			  };

		if (secure) {
			headersData = {
				...headersData,
				Authorization: `JWT ${token}`
			};
		}

		let error;
		try {
			const promise = fetch(`${rootURL}${url}`, {
				method,
				headers: {
					...headersData
				},
				body
			});

			const response = await promise;
			if (response.ok) {
				return successHandler
					? successHandler(response, actionType, dispatch, shouldDispatch)
					: defaultSuccessHandler(response, actionType, dispatch, shouldDispatch);
			} else {
				try {
					let json = response.json && (await response.json());
					json = json || {};
					error = errorHandler ? errorHandler(json, dispatch) : defaultErrorHandler(json, dispatch);
				} catch (e) {
					error = errorHandler ? errorHandler(error, dispatch) : defaultErrorHandler(error, dispatch);
				}
			}
		} catch (e) {
			error = errorHandler ? errorHandler(e) : defaultErrorHandler(e);
		}

		if (error) {
			// throw new Error(error);
			console.error(error);
		}
	};
}

async function defaultSuccessHandler(res, actionType, dispatch, shouldDispatch) {
	let json;
	try {
		json = res.json && (await res.json());
	} catch (error) {
		console.log(`Response is not a json object`); // eslint-disable-line no-console
	}
	json = json || {};
	if (shouldDispatch) {
		dispatch({
			type: actionType,
			payload: json
		});
		return json;
	} else {
		return json;
	}
}

function defaultErrorHandler(res, dispatch) {
	if (res && res.errors && res.errors.length > 0) {
		// res.errors.forEach((item) => {
		// To Do : show localized messages once the backend return error codes
		// });
	}

	const errorResponse = { hasError: true };
	console.error("Error", res);
	return errorResponse;
}
